<template lang="pug">
	.preview-zoom(v-if="Creative.loaded && Creative.SelectedCreative && Version.SelectedVersion" :style="{'left': `${Layout.getCreativesPlaneWidth() + Layout.creativesVersionsPlaneWidth + 15}px`}")
		.drag-handle(v-on:mousedown="startDrag($event)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: dragTooltipTitle}")
			i.fa.fa-arrows-alt
		InputRange(
			:default="Layout.previewZoomDefault"
			:value="Layout.previewZoom"
			:options="zoomOptions"
			:no-input="true"
			theme="dark-mini"
			v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: zoomTooltipTitle}"
			v-on:input="onZoomInput($event)"
			v-on:change="onZoomChange($event)"
		)
		.reset-btn(v-if="Layout.isPreviewZoomOrOffsetModified()" v-on:click="reset()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Reset zoom and position'}")
			i.fa.fa-rotate-left
</template>

<script>
	import Screen 				from './../../mixins/screen';
	import InputRange 			from './../Editor/Controls/InputRange';
	import { Layout } 			from './../../services/Layout';
	import { Creative } 			from './../../services/Creative';
	import { Version } 			from './../../services/Version';

	export default {
		name: 'PreviewZoom',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Preview Zoom Changed",
				"Selected Version Switched",
				"Layout Workspace Changed",
				"Layout Page Changed",
				"Aside State Changed",
				"Sub Aside State Changed"
			],
			events: {
				"Preview Zoom Changed": function() {
					this.update();
				}
			}
		},
		components: {
			InputRange
		},
		computed: {
			ctrlKeyName() {
				const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPod|iPad/i.test(navigator.userAgent || navigator.platform || '');
				return isMac ? 'Control' : 'Ctrl';
			},
			dragTooltipTitle() {
				return `Drag to pan preview. You can also hold ${this.ctrlKeyName} and drag on the preview.`;
			},
			zoomTooltipTitle() {
				return `Zoom preview. You can also hold ${this.ctrlKeyName} and scroll mouse wheel on the preview.`;
			}
		},
		data() {
			this.Layout = Layout;
			this.Creative = Creative;
			this.Version = Version;

			return {
				showed: true,
				zoomOptions: {
					changes: {
						min: 0.1,
						max: 5,
						step: 0.05,
						accuracy: 2
					},
					controlOptions: {
						min: 0.1,
						max: 5,
						step: 0.05,
						percents: true
					}
				}
			};
		},
		methods: {
			onZoomInput(value) {
				Layout.setPreviewZoom(value, false);
			},
			onZoomChange(value) {
				Layout.setPreviewZoom(value, true);
			},
			startDrag(e) {
				Layout.startPreviewDrag(e, { threshold: 0 });
			},
			reset() {
				Layout.resetPreviewZoomAndOffset();
			}
		}
	}
</script>

<style lang="sass">
	.preview-zoom
		position: absolute
		top: 56px
		z-index: 10
		display: flex
		flex-direction: row
		align-items: center
		background: transparent
		user-select: none
		gap: 6px

		.drag-handle, .reset-btn
			cursor: grab
			display: flex
			align-items: center
			justify-content: center
			width: 24px
			height: 24px
			color: rgba(255, 255, 255, 0.45)
			transition: color 0.2s ease-in-out, transform 0.15s ease-in-out

			i.fa
				font-size: 15px

			&:hover
				color: rgba(255, 255, 255, 0.95)

			&:active
				color: #20a8d8

		.reset-btn
			cursor: pointer
			&:active
				transform: rotate(-45deg)

		.drag-handle:active
			cursor: grabbing

		.editor-control-range.dark-mini
			background: transparent
			min-height: auto
			margin-top: 1px

			.range-input
				margin-left: 0
</style>
